import React from 'react'
import { Chip, Theme, useTheme } from '@mui/material'
import { Bill } from '../../types/bills'

export const getBillStatusInfo = (bill: Bill, theme: Theme) => {
    const hasPendingPayments = bill.payments.some(
        (payment) => payment.status === 'pending' && !payment.is_voided,
    )
    if (hasPendingPayments) {
        return { label: 'Pending', color: theme.palette.info.main }
    }
    if (bill.is_overdue) {
        return { label: 'Overdue', color: theme.palette.error.light }
    }
    if (bill.status === 'paid' || bill.is_paid || bill.balance_due <= 0) {
        return { label: 'Paid', color: theme.palette.success.main }
    }
    const hasPartialPayment = bill.payments.some(
        (payment) => payment.status === 'succeeded' && !payment.is_voided,
    )
    if (hasPartialPayment) {
        return { label: 'Partial', color: theme.palette.warning.main }
    }
    return { label: 'Unpaid', color: theme.palette.error.main }
}

export const BillStatusChip = ({ bill }: { bill: Bill }) => {
    const theme = useTheme()
    const status = getBillStatusInfo(bill, theme)

    return (
        <Chip
            label={status.label}
            size="small"
            sx={{
                height: 22,
                backgroundColor: `${status.color}24`,
                color: status.color,
                borderRadius: '999px',
                fontSize: '0.7rem',
                fontWeight: 700,
                '& .MuiChip-label': {
                    px: 1,
                },
            }}
        />
    )
}
